const HomeOutlined = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'>
    <path
      fill='#25314C'
      d='M10.5 12.688H8.02V9.626a1.022 1.022 0 0 0-2.04 0v3.062H3.5c-1.41 0-2.187-.777-2.187-2.187V6.797c0-1.239.341-1.585.899-2.047l3.57-2.993a1.89 1.89 0 0 1 2.436 0l3.57 2.993c.558.462.9.809.9 2.047V10.5c0 1.41-.777 2.187-2.188 2.187m-1.604-.875H10.5c.92 0 1.313-.392 1.313-1.312V6.797c0-.89-.148-1.012-.583-1.374L7.656 2.427a1.02 1.02 0 0 0-1.312 0L2.77 5.423c-.435.362-.582.483-.582 1.374V10.5c0 .92.392 1.312 1.312 1.312h1.604V9.626c0-1.046.85-1.896 1.896-1.896s1.896.85 1.896 1.896z'
    />
  </svg>
);

export default HomeOutlined;
